import type { Role } from '#/domain/role/Role'
import type { UserRepository } from '#/domain/user/UserRepository'

export class GetUserRolesUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(userId: string, organizationId?: string): Promise<Role[]> {
    return this.repository.findRoles(userId, organizationId)
  }
}
